<template>
  <div>
    <b-card title="Início do Projeto 🚀">
      <b-card-text>Seja bem-vindo</b-card-text>
      <b-card-text>Por aqui você conseguirá atualizar grupos e usinas.</b-card-text>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText, BLink } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BLink
  },
}
</script>